export default "__VITE_ASSET__BAhUKrT6__"